import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { fetchMe, type Me } from "../api/insights";

/**
 * Who is signed in and what they may see, loaded once per session.
 *
 * Only shapes the UI. The backend enforces every permission, so a stale or
 * missing value here can hide a button, never grant one.
 */
const MeContext = createContext<{ me: Me | null; loading: boolean }>({ me: null, loading: true });

export function MeProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<{ me: Me | null; loading: boolean }>({
    me: null,
    loading: true,
  });

  useEffect(() => {
    let active = true;
    fetchMe()
      .then((me) => active && setState({ me, loading: false }))
      .catch(() => active && setState({ me: null, loading: false }));
    return () => {
      active = false;
    };
  }, []);

  return <MeContext.Provider value={state}>{children}</MeContext.Provider>;
}

export const useMe = () => useContext(MeContext);
